import React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Avatar from '@mui/material/Avatar'
import ManuAvatar from '@/images/ai_avatar.jpg'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import BetaTag from './beta-tag'

const Header: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <Container
      sx={{ display: 'flex', alignItems: 'center' }}
      data-testid="header"
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '0 auto' }}>
        <Avatar src={ManuAvatar} />
        <Box sx={{ textAlignLast: 'start' }}>
          <Typography sx={{
            color: '#D0FF26', textAlign: 'center', fontSize: '20px', fontStyle: 'normal', fontWeight: 700
          }}>
            Manu
          </Typography>
          <Typography sx={{
            color: '#F2F2F2', textAlign: 'center', fontSize: '12px', fontStyle: 'normal', fontWeight: 400
          }}>
            IA Produttivo
          </Typography>
        </Box>
        <BetaTag />
      </Box>
      <Button variant='transparent' onClick={onClose}
        startIcon={<CloseIcon sx={{ color: 'white' }} />}
      />
    </Container>
  )
}

export default Header

